(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-clothing-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!customElements.get("pb-clothing-navigation")) {
    customElements.define("pb-clothing-navigation", class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => {
          const row = this.querySelector(".pb-group-nav__groups");
          const active = row == null ? void 0 : row.querySelector(".is-active");
          if (row && active && row.scrollWidth > row.clientWidth) {
            row.scrollLeft += active.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - active.offsetWidth) / 2;
          }
        });
      }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
